module.exports = __webpack_public_path__ + "static/media/guia-icon.c631b3d7.svg";